"use client";
import { useToast } from "@/components/ui/use-toast";
import { zodResolver } from "@hookform/resolvers/zod";
import { createRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";
import { z } from "zod";
import emailjs from 'emailjs-com';

const isPowerOfTwo = (n: number) => n > 0 && (n & (n - 1)) === 0;

const formSchema = z.object({
    name: z.string().min(3, {
        message: 'Ingresa tu nombre.'
    }),
    email: z.string().email({
        message: 'Ingresa un email válido para ser contactado.'
    }),
    cellphone: z.string().min(1, {
        message: 'Ingresa un celular para ser contactado.'
    }),
    message: z.string().min(20, {
        message: 'Ingresa el mensaje.'
    }).max(200, {
        message: "El máximo de caracteres permitidos son 200."
    }),
})

export const useContactForm = () => {
    const { toast } = useToast();
    const recaptchaRef = createRef<ReCAPTCHA>();

    const [isLoading, setIsLoading] = useState<boolean>(false)

    const form = useForm<z.infer<typeof formSchema>>({
        resolver: zodResolver(formSchema),
        defaultValues: {
            name: "",
            email: "",
            cellphone: "",
            message: ""
        },
    })

    async function onSubmit(values: z.infer<typeof formSchema>) {
        if (!recaptchaRef?.current) {
            toast({
                variant: 'destructive',
                title: 'Ocurrió un problema',
                description: 'Hubo un problema al realizar la petición',
            })
            return;
        };
        setIsLoading(true);

        const token = await recaptchaRef.current.executeAsync();

        emailjs
            .send(
                'service_z03h5bh',
                'template_7hszax4',
                { ...values, 'g-recaptcha-response': token, subject: 'Mensaje enviado desde página web' },
                'oX_fOEHWBOIvJtZgd'
            )
            .then(
                (response) => {
                    toast({
                        variant: 'success',
                        title: 'Consulta enviada',
                        description: 'Estaremos respondiendote al email ingresado.',
                    })
                    setIsLoading(false);
                    form.reset();
                },
                (error) => {
                    console.log(error)
                    toast({
                        variant: 'destructive',
                        title: 'Ocurrió un problema',
                        description: 'Hubo un problema al realizar la petición',
                    })
                    setIsLoading(false);
                }
            );

    }

    return {
        onSubmit,
        form,
        recaptchaRef,
        isLoading,
    }
}